<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-white nav-public">
    <div class="container">
      <div class="navbar-brand">
        <router-link
          class="nav-link-mobile-home"
          aria-current="page"
          :to="{ name: 'home' }"
        >
          <img
            src="@/assets/walkthruit-full-black.png"
            alt=""
            height="37"
            class="d-inline-block align-text-top"
          />
        </router-link>
      </div>
    </div>
  </nav>
  <div class="inner-dashboard">
    <div class="container h-100 pt-4">
      <div
        class="property-dashboard-content-heading row justify-content-between"
      >
        <div class="heading-text col-12 col-md-4 mb-4">
          <div class="current-property">
            {{ campaignName }}
          </div>
          <div class="current-route">Ad Reporting</div>
        </div>
        <div
          class="col-12 col-lg-5 buttons d-flex justify-content-end"
          v-if="isMockUser"
        >
          <button
            type="button"
            class="btn btn-primary wti-btn wti-btn-white share-button"
            data-bs-toggle="modal"
            data-bs-target="#sharePublicReportURL"
          >
            Share URL
          </button>
        </div>
      </div>
      <AdOverview
        v-if="campaignId"
        :propertyId="propertyId"
        :campaignId="campaignId"
        :token="token"
        :users="users"
      />
    </div>
    <Modal id="sharePublicReportURL" v-if="publicUrl">
      <template v-slot:title>Shareable URL</template>
      <template v-slot:body>
        <p class="border section mt-2 text-break">{{ publicUrl }}</p>
        <button
          type="button"
          v-clipboard:copy="publicUrl"
          class="btn btn-dark wti-btn-black"
        >
          Copy
        </button>
      </template>
    </Modal>
  </div>
</template>

<style lang="sass" scoped>
@use "@/assets/vars.sass" as *
.buttons .btn.share-button
  line-height: 16px
  +mobile
    margin-bottom: 10px
</style>

<script>
import { ref } from "vue";
import api from "@/services/BackendConnection";
import moment from "moment";
import PropertyDashboardContentHeading from "@/components/PropertyDashboardContentHeading.vue";
import AdOverview from "@/components/AdOverview.vue";
import Modal from "@/components/Modal.vue";

export default {
  name: "PublicAdOverviewReportView",
  setup(props) {
    return {
      campaignName: ref(null),
      startDate: ref(null),
      endDate: ref(null),
      propertyId: ref(null),
      campaignId: ref(null),
      token: ref(null),
      users: ref([]),
      campaignLoading: ref(false),
      publicUrl: ref(null),
      mockUserId: ref(import.meta.env.VITE_MOCK_ACCOUNT_ID),
    };
  },
  props: {},
  components: {
    PropertyDashboardContentHeading,
    AdOverview,
    Modal,
  },
  computed: {
    isMockUser() {
      if (this.users && this.users.includes(this.mockUserId)) {
        return true;
      }
      return false;
    },
  },
  methods: {
    getCampaignByToken() {
      var _this = this;
      var info = { token: this.token, templateName: "adOverview" };
      _this.campaignLoading = true;
      api()
        .getCampaignByToken(info)
        .then((res) => {
          if (res.data && res.data.success) {
            _this.campaignName = res.data.campaignName;
            _this.propertyId = res.data.propertyId;
            _this.campaignId = res.data.campaignId;
            _this.startDate = res.data.startDate;
            _this.endDate = res.data.endDate;
            _this.users = res.data.users;
            _this.publicUrl = res.data.publicUrl;
            _this.campaignLoading = false;
          }
        });
    },
  },
  mounted() {
    this.token = this.$route.query.token;
    this.getCampaignByToken();
  },
};
</script>
